module.exports = __webpack_public_path__ + "static/media/Ubuntu-Regular.6bb9beb4.ttf";